export default __webpack_public_path__ + "static/media/pic4.875bf575.jpg";